import React, { useState } from 'react';
import { LOGO_URL, CONTACT_INFO } from '../data/mock';
import { Phone, Instagram, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ onCategorySelect, categories }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-neutral-900/95 backdrop-blur-md border-b border-neutral-800">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-2 sm:space-x-3 flex-1 min-w-0">
            <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full overflow-hidden border-2 border-amber-500/50 shadow-md flex-shrink-0">
              <img src={LOGO_URL} alt="Mr Sweet" className="w-full h-full object-cover" />
            </div>
            <div className="flex-shrink-0">
              <h1 className="text-base sm:text-xl font-bold text-white whitespace-nowrap">Mr Sweet</h1>
              <p className="text-[10px] sm:text-xs text-neutral-400 whitespace-nowrap">Cafe & Restaurant</p>
            </div>
          </div>

          {/* Desktop Contact */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href={`tel:${CONTACT_INFO.phone.replace(/\s/g, '')}`}
              className="flex items-center space-x-2 text-neutral-300 hover:text-amber-400 transition-colors"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm">{CONTACT_INFO.phone}</span>
            </a>
            <a
              href={CONTACT_INFO.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 text-neutral-300 hover:text-amber-400 transition-colors"
            >
              <Instagram className="w-4 h-4" />
              <span className="text-sm">@{CONTACT_INFO.instagram}</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="md:hidden text-neutral-300 hover:text-amber-400 hover:bg-neutral-800"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pt-4 border-t border-neutral-800 animate-in slide-in-from-top-2">
            <div className="flex flex-col space-y-3 pb-4">
              <a
                href={`tel:${CONTACT_INFO.phone.replace(/\s/g, '')}`}
                className="flex items-center space-x-2 text-neutral-300 hover:text-amber-400 transition-colors py-2"
              >
                <Phone className="w-5 h-5" />
                <span>{CONTACT_INFO.phone}</span>
              </a>
              <a
                href={CONTACT_INFO.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-neutral-300 hover:text-amber-400 transition-colors py-2"
              >
                <Instagram className="w-5 h-5" />
                <span>@{CONTACT_INFO.instagram}</span>
              </a>
            </div>
            <div className="grid grid-cols-2 gap-2 pt-4 border-t border-neutral-800">
              {categories.map((cat) => (
                <Button
                  key={cat.id}
                  variant="ghost"
                  className="justify-start text-neutral-300 hover:text-amber-400 hover:bg-neutral-800"
                  onClick={() => {
                    onCategorySelect(cat.id);
                    setMobileMenuOpen(false);
                  }}
                >
                  {cat.name}
                </Button>
              ))}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;